import React from "react";
const Footer = () => {
    return (
   <div className = "d-block">
         <p className = "text-center" > ©Copyright 2021 NASR ACADEMY </p> 
   </div>
    )
};
export default Footer